function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.019 512.019",
    style: {
      enableBackground: "new 0 0 512.019 512.019"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 394.686,
    cy: 394.679,
    r: 117.333,
    "data-original": "#2196F3",
    className: "",
    "data-old_color": "#2196F3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00999a"
    },
    d: "M394.686,469.345c-5.891,0-10.667-4.776-10.667-10.667v-128c0-5.891,4.776-10.667,10.667-10.667   c5.891,0,10.667,4.776,10.667,10.667v128C405.352,464.57,400.577,469.345,394.686,469.345z",
    "data-original": "#FAFAFA",
    className: "",
    "data-old_color": "#00999a"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00999a"
    },
    d: "M394.686,469.345c-2.831,0.005-5.548-1.115-7.552-3.115l-42.667-42.667   c-4.093-4.237-3.976-10.99,0.261-15.083c4.134-3.993,10.688-3.993,14.821,0l35.136,35.115l35.115-35.115   c4.237-4.093,10.99-3.976,15.083,0.261c3.993,4.134,3.993,10.688,0,14.821l-42.667,42.667   C400.217,468.225,397.509,469.345,394.686,469.345z",
    "data-original": "#FAFAFA",
    className: "",
    "data-old_color": "#00999a"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.019,394.679c0.119-64.185,44.226-119.919,106.667-134.784V10.679  c0-5.891-4.776-10.667-10.667-10.667H138.686c-5.891,0-10.667,4.776-10.667,10.667v117.333H10.686  c-5.891,0-10.667,4.776-10.667,10.667v320c0,5.891,4.776,10.667,10.667,10.667h267.349  C263.667,447.092,256.023,421.167,256.019,394.679z",
    "data-original": "#CFD8DC",
    className: "",
    "data-old_color": "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.76,0.823c-3.985-1.654-8.574-0.745-11.627,2.304l-128,128  c-4.171,4.16-4.179,10.914-0.019,15.085c2.006,2.011,4.731,3.139,7.571,3.134h128c5.891,0,10.667-4.776,10.667-10.667v-128  C149.352,6.362,146.75,2.471,142.76,0.823z",
    "data-original": "#B0BEC5",
    className: "active-path",
    "data-old_color": "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.686,512.012c-64.801,0-117.333-52.532-117.333-117.333s52.532-117.333,117.333-117.333s117.333,52.532,117.333,117.333  C511.949,459.451,459.458,511.941,394.686,512.012z M394.686,298.679c-53.019,0-96,42.981-96,96s42.981,96,96,96s96-42.981,96-96  S447.705,298.679,394.686,298.679z",
    "data-original": "#000000",
    className: "",
    style: {
      fill: "#00999a"
    },
    "data-old_color": "#00999a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.352,469.345H10.686c-5.891,0-10.667-4.776-10.667-10.667v-320c-0.005-2.831,1.115-5.548,3.115-7.552l128-128  c2.004-1.999,4.721-3.12,7.552-3.115h234.667c5.891,0,10.667,4.776,10.667,10.667v234.667c0,5.891-4.776,10.667-10.667,10.667  c-5.891,0-10.667-4.776-10.667-10.667v-224H143.102L21.352,143.095v304.917h224c5.891,0,10.667,4.776,10.667,10.667  S251.243,469.345,245.352,469.345z",
    "data-original": "#000000",
    className: "",
    style: {
      fill: "#00999a"
    },
    "data-old_color": "#00999a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.686,149.345h-128c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667h117.333V10.679  c0-5.891,4.776-10.667,10.667-10.667s10.667,4.776,10.667,10.667v128C149.352,144.57,144.577,149.345,138.686,149.345z",
    "data-original": "#000000",
    className: "",
    style: {
      fill: "#00999a"
    },
    "data-old_color": "#00999a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.f05bb1d784d579aed5d5a7c7e3f3e395.svg";
export { ForwardRef as ReactComponent };